
import { PEODashboardHeader } from '@/pages/peo/PEODashboardHeader';
import { PEOProviderProfile } from '@/pages/peo/PEOProviderProfile';
import { QuotesList } from './QuotesList';
import { useState } from 'react';
import { toast } from 'sonner';

interface PEODashboardContentProps {
  loading: boolean;
  onRefresh: () => void;
  onLogout: () => void;
  providerInfo: any;
  isEditing: boolean;
  setIsEditing: (isEditing: boolean) => void;
  form: {
    name: string;
    contact_email: string;
    years_in_business: string;
    employee_range: string;
  };
  setForm: React.Dispatch<React.SetStateAction<any>>;
  onSave: (e: React.FormEvent) => void;
  saving: boolean;
}

export const PEODashboardContent = ({
  loading,
  onRefresh,
  onLogout,
  providerInfo,
  isEditing,
  setIsEditing,
  form,
  setForm,
  onSave,
  saving,
}: PEODashboardContentProps) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white to-gray-50 p-6">
      <div className="max-w-7xl mx-auto space-y-8">
        <PEODashboardHeader loading={loading} onRefresh={onRefresh} onLogout={onLogout} />
        
        {/* Provider Profile Card with slight shadow */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
          <PEOProviderProfile
            providerInfo={providerInfo}
            isEditing={isEditing}
            setIsEditing={setIsEditing}
            form={form}
            setForm={setForm}
            onSave={onSave}
            saving={saving}
          />
        </div>
        
        {/* Quotes List */}
        <div className="pb-8">
          {providerInfo && <QuotesList providerId={providerInfo.id} />}
        </div>
      </div>
    </div>
  );
};
